import { render, staticRenderFns } from "./BasicLayoutSidebar.vue?vue&type=template&id=88ca58f4&scoped=true&"
import script from "./BasicLayoutSidebar.vue?vue&type=script&lang=js&"
export * from "./BasicLayoutSidebar.vue?vue&type=script&lang=js&"
import style0 from "./BasicLayoutSidebar.vue?vue&type=style&index=0&id=88ca58f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88ca58f4",
  null
  
)

export default component.exports